import { UniversityStudyRoomTemplate } from "@/components/UniversityStudyRoomTemplate";

const UniversityOfWashington = () => {
  return (
    <UniversityStudyRoomTemplate
      universityName="University of Washington"
      universityShortName="UW"
      slug="university-of-washington"
      seoTitle="UW Study Rooms | University of Washington Seattle Library Study Spaces"
      seoDescription="Find study rooms at UW including Suzzallo and Odegaard Libraries. Learn booking policies and discover CSW as an online alternative."
      seoKeywords="UW study rooms, University of Washington library, Seattle study spaces, Husky study rooms, Suzzallo Library"
      canonicalUrl="/study-room/university-of-washington/"
      heroDescription="Explore UW's iconic libraries from the Hogwarts-like Suzzallo to modern Odegaard."
      libraryWebsiteUrl="https://lib.uw.edu"
      libraryWebsiteName="UW Libraries"
      studySpaces={[
        {
          name: "Odegaard Library - Collaborative Rooms",
          features: "Modern study pods and group rooms, tech-equipped, reservable.",
          feedback: "Ideal for group projects. Rooms fill quickly during finals."
        },
        {
          name: "Odegaard - Sound-Resistant Booths",
          features: "First floor booths for video calls and focused work.",
          feedback: "Perfect for Zoom calls and online meetings."
        },
        {
          name: "Suzzallo Library - Reading Room",
          features: "Hogwarts-like atmosphere, quiet study, historic architecture.",
          feedback: "Beautiful but strict noise enforcement. Limited outlets."
        },
        {
          name: "Allen Library",
          features: "Quiet floors, individual study spaces.",
          feedback: "Good for solo study. Some limited power outlet availability."
        }
      ]}
      guideContent={
        <>
          <p>
            UW Libraries permit students to reserve study rooms for up to three hours per day with reservations 
            open two weeks in advance. Users must have a valid UW NetID and check in within 15 minutes.
          </p>
          <p className="mt-4">
            Students appreciate the modern study pods and group rooms but note that many rooms fill quickly. 
            Some critique the older Suzzallo and Allen libraries for limited power outlets and strict noise enforcement.
          </p>
          <p className="mt-4">
            Reserve rooms early and explore the specialized spaces: Odegaard Library's collaborative rooms are ideal 
            for group projects, while the quiet reading rooms in Suzzallo provide a Hogwarts-like atmosphere. 
            For video calls, use the sound-resistant booths on the first floor of Odegaard.
          </p>
        </>
      }
      summaryTips={[
        "Book up to 2 weeks in advance, 3 hours max per day",
        "Check in within 15 minutes with UW NetID",
        "Suzzallo Reading Room has Hogwarts-like atmosphere",
        "Odegaard has sound-resistant booths for video calls",
        "Older libraries have limited power outlets"
      ]}
    />
  );
};

export default UniversityOfWashington;
